import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { WeatherReportAdd, WeatherReportGrabber } from './WeatherReportSidebar';
import { WeatherReportEdit } from './admin/WeatherReportEdit';
import { WeatherReportGuest } from './guest/WeatherReportGuest';
import { WEATHER_REPORT_SCHEMA_URL } from './WeatherReport.helpers';

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const WeatherReportConfig: CustomJsonComponentConfig = {
  schemaUrl: WEATHER_REPORT_SCHEMA_URL,
  componentType: 'WeatherReport',
  adminSidebarComponent: {
    addComponentView: WeatherReportAdd,
    dragComponentView: WeatherReportGrabber,
    editComponentView: WeatherReportEdit,
    createComponentView: WeatherReportEdit,
  },
  guestSiteComponent: WeatherReportGuest,
};
